import axios from 'axios';

export let headers = {
  'Tenant-Access-Token': 'NzRkMTU1OGY1ZDcyNDhiMTYxNTUxOTZhZjhlOWY3M2Y=',
  'Tenant-Access-Key': 'tz-dxrVBjRAjQQ',
};

export const BASE_URL = 'https://immersive-game-india.confirmu.com';

export const api = axios.create({
  baseURL: BASE_URL,
  headers: headers
});

